import React from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledTooltip,
} from 'reactstrap';

import "assets/scss/base.css";

const ToolTip = ({ title, hidden, placement, target }) => {
  if (hidden) {
    return null;
  }

  return (
    <UncontrolledTooltip
      placement={placement}
      target={target}
      className="custom-tooltip"
    >
      {title}
    </UncontrolledTooltip>
  );
};

ToolTip.propTypes = {
  title: PropTypes.string,
  hidden: PropTypes.bool,
  placement: PropTypes.string,
  target: PropTypes.string
};
 
export default ToolTip;



// WEBPACK FOOTER //
// ./src/components/Tooltip.js